<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid  ref="xGrid"  class="vggrid" :list="list" tableheight="700" flexname="" :cols="cols"
            :showfooter="false" :showPage="true" :resizable="true"
            :total="query.total" @cellClick="cellClick"  @cellDblClick="viewProject" @pagechange="pagechange"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>

  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'psuIndex',
    data () {
      return {
        menuid: this.$route.query.menuid || this.$route.params.menuid,
        list: [],
        btn:{},
        btnLoading: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'projectcode', fieldtype: 'C', title: '项目编号',calculExpr:'',addNewRowFlg: false},
          { field: 'projectname', fieldtype: 'C', title: '项目名称',calculExpr:'',addNewRowFlg: false},
          { field: 'username', fieldtype: 'C', title: '报名人',calculExpr:'',addNewRowFlg: false},
          { field: 'psutime', fieldtype: 'C', title: '报名时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']},
          { field: 'prsbjbegtime', fieldtype: 'C', title: '竞价开始时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']},
          { field: 'prsbjendtime', fieldtype: 'C', title: '竞价截止时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']},
          { title: '状态', width: 160, showOverflow: true,
            slots: {
              default: 'default',
              default: ({row}) => {
                return [
                  row.psustatus === '3' ? <vxe-button onClick={this.bmxx.bind(this, row)} status="primary">审核不通过</vxe-button>:row.psustatusname
                ]
              }}
          }
        ],
        psu: {},
        query: {
          comid: this.$store.getters.loginUser.comid,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('FEEPAY', () => this.feePay())
      this.$on('BZJPAY', () => this.bzjPay())
      this.$on('BMXX',()=>this.bmxx())
      this.$on('UPLOADFILE', () => this.uploadFile())
      this.$on('PBRLIST', () => this.pbrList())
      this.$on('CLOSE', () => this.close())
    },
    async activated() {
      await this.init()
      await this.getPageList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.psu = row
        this.project = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async init() {
        this.query = {
          comid: this.$store.getters.loginUser.comid,
          total: 0,
          limit: 20,
          offset: 0}
        this.list = []
        this.btnLoading = false
        this.psu = {}
        this.menuid = this.$route.query.menuid || this.$route.params.menuid
      },
      async viewProject(row) {
        this.project = row.row
        this.$router.push({name: 'projectView', params: {projectid: this.project.projectid, type: 1, activeName: 'bmxx'}})
      },
      async pbrList () {
        if (!this.psu.psuid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        this.$router.push({name: 'pbrListForm', params: {form: this.project, type: 1}})
      },
      uploadFile () {
        if (!this.psu.psuid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        if (+this.psu.psustatus === 2) {
          this.$message.warning('报名信息已审核，不能上传附件!')
          return
        }
        if (+this.project.projectstatus > 20) {
          this.$message.warning(`项目已进入${this.project.projectstatusname}，无需支付!`)
          return
        }
        this.$router.push({name: 'psuBmUploadFileForm', params: {form: this.psu, type: 1}})
      },
      async feePay () {
        if (!this.psu.psuid) {
          this.$message.warning('请选择一个项目!')
          return
        }

        // if (+this.psu.psustatus === 2) {
        //   this.$message.warning('报名信息已审核，无需支付!')
        //   return
        // }
        // if (+this.project.projectstatus > 20) {
        //   this.$message.warning(`项目已进入${this.project.projectstatusname}，无需支付!`)
        //   return
        // }
        console.log('===============',this.psu);
        this.$router.push({name: 'psuBmPayForm', params: {form: this.psu, type: 1}})
      },
      async bzjPay () {
        // if (!this.psu.psuid) {
        //   this.$message.warning('请选择一个项目!')
        //   return
        // }
        // // if (+this.psu.psustatus === 2) {
        // //   this.$message.warning('报名信息已审核，无需支付!')
        // //   return
        // // }
        // if (+this.project.projectstatus > 20) {
        //   this.$message.warning(`项目已进入${this.project.projectstatusname}，无需支付!`)
        //   return
        // }
        console.log('===============',this.psu);
        this.$router.push({name: 'psuBzjPayForm', params: {form: this.psu, type: 1}})
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async delProject () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xmgl/project/delPsu',
            method: "post",
            data: this.psu
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      async cellClick (row) {
        this.psu = row.row
        this.project = row.row
        console.log('this.psu',this.psu);

      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        this.query.cosid = this.$store.getters.loginUser.cosid
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getPsuListByComId',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      },
      bmxx(row) {
        if (!row) {
          if (!this.psu.psuid) {
            this.$message.warning('请选择一个项目!')
            return
          }
        }
        if(this.project.psustatusname == '审核通过'){
          this.$message.warning('审核已通过')
          return
        }
        let flg = 1;
        this.$router.push({name: 'psuBmForm', params: {form: this.project, type: 1,type: flg}})
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
